




















































import { Component, Mixins, Prop } from 'vue-property-decorator'
import { find, sortBy } from 'lodash'
import { Exercise } from '@/interfaces'
import AdminEditMixin from '@/mixins/AdminEditMixin'

@Component
export default class AdminEditExercise extends Mixins(AdminEditMixin) {
  @Prop({ default: '' }) exerciseId!: string

  selected: Exercise|null = null

  mounted () {
    this.selected = find(this.sortedExercise, { id: this.exerciseId }) || null
  }

  get sortedExercise (): Exercise[] {
    return sortBy(this.$store.getters['exercises/all'], 'name.en')
  }

  addExercise () {
    this.selected = {
      id: '',
      description: { en: '' },
      name: { en: '' },
      tags: []
    }
  }

  async removeExercise (exercise: Exercise) {
      try {
      await this.$store.dispatch('exercises/removeBase', exercise)

      this.selected = null
    } catch (error) {
      // TODO: display some kind of useful error message
    } finally {
      this.hideConfirmRemoveDialog()
    }
  }

  saveExercise (exercise: Exercise) {
    this.$store.dispatch('exercises/saveBase', exercise)
  }

  setActive (exercise: Exercise) {
    this.selected = exercise
    this.$router.push({ name: 'admin-edit-exercise', params: { exerciseId: exercise.id } })
  }
}
